// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MaxDryRunCmp from "./MaxDryRunCmp.bs.js";
import * as DryRunRatioCmp from "./DryRunRatioCmp.bs.js";
import * as AllocationRadiusCmp from "./AllocationRadiusCmp.bs.js";

function AllocationFilterWrapper(Props) {
  var filter_data = Props.filter_data;
  var show_header = Props.show_header;
  switch (filter_data.TAG | 0) {
    case /* AllocationRadius */0 :
        return React.createElement("div", {
                    className: "ald-filter"
                  }, show_header ? React.createElement("div", {
                          className: "ald-filter-header"
                        }, React.createElement("div", {
                              className: "header-name"
                            }, "Allocation Radius"), React.createElement("div", {
                              className: "header-sub-section"
                            }, "Auto - Manual")) : null, React.createElement("div", {
                        className: "ald-filter-body"
                      }, React.createElement(AllocationRadiusCmp.make, {
                            filter_data: filter_data
                          })));
    case /* DryRun */1 :
        return React.createElement("div", {
                    className: "ald-filter"
                  }, show_header ? React.createElement("div", {
                          className: "ald-filter-header"
                        }, React.createElement("div", {
                              className: "header-name"
                            }, "Dry Run Ratio [Auto]"), React.createElement("div", {
                              className: "header-sub-section"
                            }, "Threshold - Ratio")) : null, React.createElement("div", {
                        className: "ald-filter-body"
                      }, React.createElement(DryRunRatioCmp.make, {
                            filter_data: filter_data
                          })));
    case /* MaxDryRun */2 :
        return React.createElement("div", {
                    className: "ald-filter"
                  }, show_header ? React.createElement("div", {
                          className: "ald-filter-header"
                        }, React.createElement("div", {
                              className: "header-name"
                            }, "Max Dry Run"), React.createElement("div", {
                              className: "header-sub-section"
                            }, "Auto - Manual")) : null, React.createElement("div", {
                        className: "ald-filter-body"
                      }, React.createElement(MaxDryRunCmp.make, {
                            filter_data: filter_data
                          })));
    
  }
}

var make = AllocationFilterWrapper;

export {
  make ,
  
}
/* react Not a pure module */
